import { httpClient } from '@shared/infrastructure/http/http-client.js';
import type { EngineChangelog } from '../model.js';

interface ReleasePayload {
  version: string;
  date?: string | null;
  changes?: string[];
}

interface ChangelogPayload {
  engines?: Array<{ engine: string; releases?: ReleasePayload[] }>;
}

/**
 * Boundary with the engines' changelog.
 *
 * The texts live in Virtual Profiler's code, next to the engines they describe, and arrive in
 * English: they are shown verbatim, never translated here. The gateway has already dropped the
 * malformed rows; what is left to this side is not tripping over an absent list. Order is kept as
 * it comes — engines as upstream lists them, releases newest first — and choosing which engines a
 * screen shows, and in what order, is `lib/engine-changelog.ts`'s business.
 */
export const engineChangelogApi = {
  list: async (): Promise<EngineChangelog[]> => {
    const payload = await httpClient.get<ChangelogPayload>('/virtual-profiler/engine-changelog');

    return (payload.engines ?? []).map((entry) => ({
      engine: entry.engine,
      releases: (entry.releases ?? []).map((release) => ({
        version: release.version,
        date: release.date ?? null,
        changes: release.changes ?? [],
      })),
    }));
  },
};
